import { render, staticRenderFns } from "./base-input-number-horizontal.vue?vue&type=template&id=f1519bb8&scoped=true"
import script from "./base-input-number-horizontal.vue?vue&type=script&lang=ts"
export * from "./base-input-number-horizontal.vue?vue&type=script&lang=ts"
import style0 from "./base-input-number-horizontal.vue?vue&type=style&index=0&id=f1519bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1519bb8",
  null
  
)

export default component.exports